<script lang="ts" generics="TValues">
    import Row from '$components/Form/Row.svelte';
    import type { Form } from '@jmvdevelop/svelte-form';
    import type { Fields } from '$components/MultiQuoteForm/MultiQuoteFormData';
    import Select from '$components/Form/Select.svelte';
    import PrettyChoice from '$components/Form/PrettyChoice.svelte';
    import Textarea from '$components/Form/Textarea.svelte';

    export let form: Form<TValues, string>;
    export let fields: Fields<TValues>;

    const medicalServiceOptions = [
        `Accouchement`,
        `Cardiologie`,
        `Chirurgie`,
        `Dermatologie`,
        `Gynécologie`,
        `Médecine générale`,
        `Ophtalmologie`,
        `ORL`,
        `Pédiatrie`,
        `Psychologie`,
        `Autre`,
    ].map((v) => ({ label: v, value: v, key: v }));

    const consultationTypeOptions = [`Urgence`, `Rendez-vous programmé`].map((v) => ({
        label: v,
        value: v,
        key: v,
    }));

    const hospitalizationInfoOptions = [`Oui`, `Non`].map((v) => ({
        label: v,
        value: v,
        key: v,
    }));
</script>

<div class="flex flex-col gap-8 @container">
    <Row
        {form}
        field={fields.cliniques.medicalService}
        class=""
        let:field
        let:id
        label={`Quel type de service médical recherchez-vous ?`}
    >
        <Select
            {form}
            {field}
            {id}
            required={false}
            options={medicalServiceOptions}
            placeholder="Sélectionnez un service médical"
        />
    </Row>

    <Row
        {form}
        field={fields.cliniques.consultationType}
        class=""
        let:field
        let:id
        label={`Avez-vous besoin d'une consultation urgente ou d'un rendez-vous programmé ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[400px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={consultationTypeOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.cliniques.hospitalizationInfo}
        class=""
        let:field
        let:id
        label={`Souhaitez-vous des informations sur les services d'hospitalisation ou de soins intensifs ?`}
    >
        <PrettyChoice
            {form}
            {field}
            {id}
            defaultClass="grid grid-cols-1 @[200px]:grid-cols-2 gap-x-6 gap-y-1"
            choices={hospitalizationInfoOptions}
        />
    </Row>

    <Row
        {form}
        field={fields.message}
        required
        label={'Votre demande'}
        helpLabel="Précisez votre besoin : localisation, délais…"
        let:field
    >
        <Textarea
            {form}
            {field}
            placeholder={`Précisez votre besoin : localisation, délais…`}
            toText={(id) => id}
            fromText={(id) => id}
            class={''}
            rows={5}
        />
    </Row>
</div>
